import { AppProviders } from '../providers/AppProviders'
import { AppRoutes } from '../routing/AppRoutes'
import { Layout } from '../ui'

function App() {
  return (
    <AppProviders>
      <Layout>
        <AppRoutes />
      </Layout>
    </AppProviders>
  )
}

// eslint-disable-next-line import/no-default-export
export default App
